import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import benLogo from 'components/assets/img/ben_logo.svg';

import './ScreensUserAccessDenied.scss';

const AccessDenied = React.lazy(
  () => import('components/User/AccessDenied/AccessDenied'),
);

const cbn = 'access-denied-screen';

function ScreensUserAccessDenied() {
  return (
    <div className={`${cbn}__window`}>
      <DocumentTitle>Access Denied</DocumentTitle>
      <div className={`${cbn}__container`}>
        <div className={`${cbn}__logo`}>
          <img src={benLogo} alt="BENlabs" />
        </div>
        <div className={`${cbn}__wrapper`}>
          <Suspense fallback={<UILoader />}>
            <AccessDenied />
          </Suspense>
        </div>
      </div>
    </div>
  );
}

export default ScreensUserAccessDenied;
